// src/components/DisList.jsx
import React, { useEffect, useState, useMemo, useRef } from 'react';
import DelBox from '../comps/DelBox';
import AppConst from "../apis/appconst";
import axios from "axios";
import jsPDF from 'jspdf';
import QRCode from 'qrcode';
import JsBarcode from 'jsbarcode';
import autoTable from 'jspdf-autotable';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import DataTable from 'react-data-table-component';


const DisList = () => {
  const [formData, setFormData] = useState({
    l1: [],
    wards: [],
    doc: [],
    page_no: 0,
    from: "",
    to: "",
    search_key: "",
  });

  const [cachedList, setCachedList] = useState([]); // last successful server list

  const [finalPayment, setFinalPayment] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [duePayment, setDuePayment] = useState(0);
  const [computedDue, setComputedDue] = useState(0);
  const [payAmount, setPayAmount] = useState('');
  const [computedPaid, setComputedPaid] = useState(0);
  const [image, setImage] = useState('');
  const [ldata, setLdata] = useState(null);
  const [loading, setLoading] = useState(false);
  const searchTimer = useRef(null);
  const DEBOUNCE_MS = 400;
  const [transactionHistory, setTransactionHistory] = useState([]);
  const [isFetchingTxns, setIsFetchingTxns] = useState(false);
function formatDate2(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  if (isNaN(date)) return dateStr;
  const day = String(date.getDate()).padStart(2, '0');
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}
  // ----------------- Helpers -----------------
  const isObj = (v) => v && typeof v === 'object' && !Array.isArray(v);
  const safeStr = (v) => (v === null || v === undefined) ? '' : String(v);
  const safeNum = (v) => {
    const n = Number(v);
    return Number.isNaN(n) ? 0 : n;
  };
  const toFixed2 = (v) => {
    const n = safeNum(v);
    return n.toFixed(2);
  };

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function parseServerDate(datetimeStr) {
    if (!datetimeStr) return null;
    const s = String(datetimeStr).trim();
    // Try ISO parse fallback
    // If it's like 'YYYY-MM-DD' or 'YYYY-MM-DDTHH:MM:SS', Date can parse in most browsers as UTC,
    // but prefer component parsing for safer local result.
    const isoMatch = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2}):?(\d{2})?)?/);
    if (isoMatch) {
      const y = parseInt(isoMatch[1], 10);
      const m = parseInt(isoMatch[2], 10) - 1;
      const d = parseInt(isoMatch[3], 10);
      const hh = isoMatch[4] ? parseInt(isoMatch[4], 10) : 0;
      const mm = isoMatch[5] ? parseInt(isoMatch[5], 10) : 0;
      const ss = isoMatch[6] ? parseInt(isoMatch[6], 10) : 0;
      return new Date(y, m, d, hh, mm, ss);
    }
    const dt = new Date(s);
    if (!isNaN(dt.getTime())) return dt;
    return null;
  }

  function formatDateTime12h(dateInput) {
    if (!dateInput && dateInput !== 0) return '';
    let dateObj = dateInput instanceof Date ? dateInput : parseServerDate(dateInput);
    if (!dateObj) {
      try { dateObj = new Date(dateInput); } catch { dateObj = null; }
    }
    if (!(dateObj instanceof Date) || isNaN(dateObj.getTime())) return '';
    const day = String(dateObj.getDate()).padStart(2, '0');
    const monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    const month = monthNames[dateObj.getMonth()];
    const year = dateObj.getFullYear();
    let hours = dateObj.getHours();
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours === 0 ? 12 : hours;
    const hourStr = String(hours).padStart(2, '0');
    return `${day} ${month}- ${year} ${hourStr}:${minutes} ${ampm}`;
  }

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const d = parseServerDate(dateString) || new Date(dateString);
    if (!d || isNaN(d.getTime())) return String(dateString);
    return `${String(d.getDate()).padStart(2,'0')}-${String(d.getMonth()+1).padStart(2,'0')}-${d.getFullYear()}`;
  };



  // amount in words (simple Indian style)
  function amountInWords(amount) {
    amount = Number(amount) || 0;
    if (amount === 0) return 'zero';
    const words = [
      '', 'one','two','three','four','five','six','seven','eight','nine','ten',
      'eleven','twelve','thirteen','fourteen','fifteen','sixteen','seventeen','eighteen','nineteen'
    ];
    const tens = ['', '', 'twenty','thirty','forty','fifty','sixty','seventy','eighty','ninety'];
    function twoDigit(n) {
      if (n < 20) return words[n];
      const t = Math.floor(n/10);
      const u = n % 10;
      return tens[t] + (u ? ' ' + words[u] : '');
    }
    function threeDigit(n) {
      const h = Math.floor(n/100);
      const rem = n % 100;
      return (h ? words[h] + ' hundred' + (rem ? ' ' : '') : '') + (rem ? twoDigit(rem) : '');
    }
    let n = Math.floor(amount);
    const parts = [];
    const crore = Math.floor(n / 10000000);
    if (crore) { parts.push(threeDigit(crore) + ' crore'); n = n % 10000000; }
    const lakh = Math.floor(n / 100000);
    if (lakh) { parts.push(threeDigit(lakh) + ' lakh'); n = n % 100000; }
    const thousand = Math.floor(n / 1000);
    if (thousand) { parts.push(threeDigit(thousand) + ' thousand'); n = n % 1000; }
    if (n) parts.push(threeDigit(n));
    return parts.join(' ').replace(/\s+/g, ' ').trim();
  }

  // ----------------- small getters for UI -----------------
  function getDoctorNameById(id) {
    if (!formData.doc || !Array.isArray(formData.doc)) return '';
    const d = formData.doc.find(x => String(x.user_id) === String(id));
    return d ? (d.fname || '') : '';
  }
  function getWardNameById(id) {
    const wlist = formData.wards || [];
    const w = wlist.find(x => String(x.cat_id) === String(id));
    return w ? (w.cat_name || '') : '';
  }
  function getBedNameById(bedId) {
    const wards = formData.wards || [];
    for (let w of wards) {
      if (!w || !Array.isArray(w.beds)) continue;
      const b = w.beds.find(bd => String(bd.bed_id) === String(bedId));
      if (b) return b.bed_name || '';
    }
    return '';
  }

  // ----------------- fetch transaction history (used in several places) -----------------
  // fetch transaction history by bill id (payment_parent_bill_id)
  const fetchTransactionHistory = async (billIdOrUhid) => {
    if (!billIdOrUhid) return [];
    setIsLoading(true);
    try {
      const idToUse = String(billIdOrUhid || '').trim();
      if (!idToUse) return [];
      const endpoints = [ AppConst.GetPaymentIpdBill, AppConst.GetPaymentIpdBill2 ].filter(Boolean);
      let payments = [];
      for (const ep of endpoints) {
        try {
          const url = `${AppConst.BASE_URL + ep}/${encodeURIComponent(idToUse)}`;
          const resp = await axios.get(url);
          const payload = resp?.data || {};
          payments = payload.history || payload.records || payload.payments ||
                     Object.values(payload).find(v => Array.isArray(v) && v.length) || [];
          if (Array.isArray(payments) && payments.length) break;
        } catch (e) { /* try next endpoint */ }
      }
      setTransactionHistory(Array.isArray(payments) ? payments : []);
      return Array.isArray(payments) ? payments : [];
    } catch (error) {
      console.error('Failed to fetch transaction history', error);
      setTransactionHistory([]);
      return [];
    } finally {
      setIsLoading(false);
    }
  };
  
  


  // Recalculate computedPaid and computedDue whenever transactions, advance or final amount change
  useEffect(() => {
    const adv = Number(formData.ipd_bill_adv_amount || 0);
    const finalAmt = Number(formData.ipd_bill_final_amt || 0);
    const transSum = (transactionHistory || []).reduce((s, t) => s + (Number(t.payment_amount || t.amount || 0)), 0);
    const newPaid = adv + transSum;
    const newDue = Math.max(0, finalAmt - newPaid);
    setComputedPaid(newPaid);
    setComputedDue(newDue);
    setFormData(prev => {
      const prevPaid = Number(prev.ipd_bill_paid || 0);
      const prevDue = Number(prev.ipd_bill_due || 0);
      if (prevPaid === newPaid && prevDue === newDue) return prev;
      return { ...prev, ipd_bill_paid: newPaid, ipd_bill_due: newDue };
    });
    setDuePayment(newDue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transactionHistory, formData.ipd_bill_adv_amount, formData.ipd_bill_final_amt]);

  useEffect(() => {
    const uh = formData.ipd_bill_uhid;
    const billId = formData.ipd_bill_id || formData.ipd_no;
    const idToUse = uh || billId;
    if (idToUse) fetchTransactionHistory(idToUse);
    // eslint-disable-next-line
  }, [formData.ipd_bill_uhid, formData.ipd_bill_id, formData.ipd_no]);
  
  const fetchLabDataForBill = async (ipdNo) => {
  const empty = { records: [], detailsMap: {}, final: 0, paid: 0, due: 0 };
  if (!ipdNo) return empty;

  try {
    const fd = new FormData();
    fd.append('page_no', 'none');
    fd.append('ipd_id', String(ipdNo));
    const resp = await axios.post(
      AppConst.BASE_URL + AppConst.getLabRegListItmUrl, fd,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    const rows = (resp?.data?.status && Array.isArray(resp.data.records)) ? resp.data.records : [];
    if (!rows.length) return empty;

    // group item rows -> one record per lab_reg_id
    const regMap = {};
    const detailsMap = {};
    rows.forEach(r => {
      const rid = String(r.lab_reg_id || r.lab_item_parent || '');
      if (!rid) return;
      if (!regMap[rid]) {
        regMap[rid] = {
          lab_reg_id: rid,
          lab_reg_date: r.lab_reg_date || r.lab_reg_datetime || '',
          lab_total: Number(r.lab_total || 0),
          lab_final_amt: Number(r.lab_final_amt || 0),
          lab_paid: Number(r.lab_paid || 0),
          lab_due: Number(r.lab_due || 0),
        };
        detailsMap[rid] = { testItems: [], tests: [], payments: [] };
      }
      const unit = Number(r.lab_item_test_price ?? 0);
      const total = Number(r.lab_item_total ?? unit);
      const name = r.lab_item_test_name || r.test_name || r.name || '';
      if (name) {
        detailsMap[rid].testItems.push({ name, unit, total, discount: Math.max(0, unit - total) });
        detailsMap[rid].tests.push(name);
      }
    });

    // payment history per lab registration
    await Promise.all(Object.keys(detailsMap).map(async (rid) => {
      try {
        const fp = new FormData();
        fp.append('lab_reg_id', rid);
        const pr = await axios.post(
          AppConst.BASE_URL + AppConst.getPaymentHistoryUrl, fp,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        detailsMap[rid].payments = (pr?.data?.status && Array.isArray(pr.data.records)) ? pr.data.records : [];
      } catch (e) {
        detailsMap[rid].payments = [];
      }
    }));

    const records = Object.values(regMap);
    return {
      records,
      detailsMap,
      final: records.reduce((s, r) => s + Number(r.lab_final_amt || 0), 0),
      paid:  records.reduce((s, r) => s + Number(r.lab_paid || 0), 0),
      due:   records.reduce((s, r) => s + Number(r.lab_due || 0), 0),
    };
  } catch (err) {
    console.warn('fetchLabDataForBill error', err);
    return empty;
  }
};

// Advance history / usage / bill-no source (same endpoint IPD Billing uses)
const fetchAdvanceInfo = async (uhid) => {
  const empty = { history: [], usage: [], usedTotal: 0, billNoSource: null };
  if (!uhid) return empty;
  try {
    const fd = new FormData();
    fd.append('ipd_uhid', uhid);
    const r = await axios.post(AppConst.BASE_URL + AppConst.getIpdBillByIdUrl, fd);
    if (!r?.data?.status) return empty;
    return {
      history: Array.isArray(r.data.advance_history) ? r.data.advance_history : [],
      usage: Array.isArray(r.data.advance_usage) ? r.data.advance_usage : [],
      usedTotal: Number(r.data.advance_used_total || 0),
      billNoSource: r.data.bill_no_source || null,
    };
  } catch (e) {
    return empty;
  }
};

const fetchReturnHistoryFor = async (uhid) => {
  if (!uhid) return [];
  try {
    const fd = new FormData();
    fd.append('uhid', uhid);
    const r = await axios.post(
      AppConst.BASE_URL + AppConst.getIpdReturnHistoryUrl, fd,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return (r?.data?.status && Array.isArray(r.data.records)) ? r.data.records : [];
  } catch (e) {
    return [];
  }
};

// Bill line items (the row may not carry them)
const fetchBillItemsFor = async ({ uhid, ipdNo, billId }) => {
  if (!uhid && !ipdNo && !billId) return [];
  try {
    const fd = new FormData();
    if (uhid) fd.append('ipd_uhid', uhid);
    if (ipdNo) fd.append('ipd_no', ipdNo);
    if (billId) fd.append('ipd_bill_id', billId);
    const r = await axios.post(
      AppConst.BASE_URL + AppConst.getIpdBillItemsUrl, fd,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return (r?.data?.status && Array.isArray(r.data.records)) ? r.data.records : [];
  } catch (e) {
    return [];
  }
};

// Same aggregation IPD Billing uses: duplicate test name -> qty + 1
const buildInvestigationRowsFrom = (records = [], detailsMap = {}) => {
  const map = new Map();
  (records || []).forEach(rec => {
    const det = detailsMap[rec.lab_reg_id] || {};
    (det.testItems || []).forEach(t => {
      const key = (t.name || '').toLowerCase().trim();
      if (!key) return;
      const unit = Number(t.unit || 0);
      const total = Number(t.total ?? unit);
      const disc = Number(t.discount ?? Math.max(0, unit - total));
      if (map.has(key)) {
        const ex = map.get(key);
        ex.qty += 1;
        ex.discount += disc;
        ex.final += total;
      } else {
        map.set(key, { name: t.name, qty: 1, unit, discount: disc, final: total });
      }
    });
  });
  return Array.from(map.values());
};

  // ----------------- generatePDF (single consolidated version) -----------------
  const imageUrlToBase64 = async (url) => {
    if (!url) return null;
    try {
      const resp = await fetch(url);
      if (!resp.ok) return null;
      const blob = await resp.blob();
      return await new Promise((resolve, reject) => {
        const r = new FileReader();
        r.onloadend = () => resolve(r.result);
        r.onerror = reject;
        r.readAsDataURL(blob);
      });
    } catch (e) {
      console.error(e);
      return null;
    }
  };

   // Replace your generatePDF with this safe version
  // Robust generatePDF — safe: no const reassignment, guarded maps, fallback lookups
const generatePDF = async (dataParam, options = {}, ctx = {}) => {
  const data = dataParam || {};
  const {
    includeHeader = true,
    includeLab = true,
    includePharmacy = true,
  } = options;

  const labRecords      = ctx.labRecords || [];
  const labDetails      = ctx.labDetails || {};
  const labFinal        = Number(ctx.labFinal || 0);
  const labPaid         = Number(ctx.labPaid || 0);
  const labDue          = Number(ctx.labDue || 0);
  const pharmacyFinal   = Number(ctx.pharmacyFinal || 0);
  const advanceHistory  = ctx.advanceHistory || [];
  const advanceUsage    = ctx.advanceUsage || [];
  const advanceUsedTotal= Number(ctx.advanceUsedTotal || 0);
  const returnHistory   = ctx.returnHistory || [];
  const billNoSource    = ctx.billNoSource || null;
  const transactions    = Array.isArray(ctx.transactions) ? ctx.transactions : [];
  const otitems         = Array.isArray(ctx.items) ? ctx.items : [];

  const doc = new jsPDF();
  const pageHeight = doc.internal.pageSize.getHeight();
  const pageWidth  = doc.internal.pageSize.getWidth();
  const headerColor = [180, 220, 250];
  let y = 0;

  const ensureSpace = (needed = 10) => {
    if (y + needed > pageHeight - 15) { doc.addPage(); y = 20; }
  };

  // ===== HEADER =====
  if (includeHeader) {
    try {
      const headerImageBase64 = await imageUrlToBase64(image);
      if (headerImageBase64) doc.addImage(headerImageBase64, 'PNG', 0, 0, pageWidth, 30);
    } catch (e) { console.warn('header image error', e); }
  }
  y = 38;

  doc.setFontSize(14).setFont('helvetica', 'bold');
  doc.text('IPD Final Bill', pageWidth / 2, y, { align: 'center' });
  y += 2;

  // ===== BARCODE =====
  const uhidVal = data.ipd_bill_uhid || data.uhid || '';
  let barcodeDataUrl = null;
  try {
    if (uhidVal) {
      const canvas = document.createElement('canvas');
      JsBarcode(canvas, String(uhidVal), { format: 'CODE128', displayValue: false, height: 25, margin: 0 });
      barcodeDataUrl = canvas.toDataURL('image/png');
    }
  } catch (e) { console.warn('barcode err', e); }

  // ===== BILL NO (advance payment id first, then latest payment) =====
  const latestPayment = transactions
    .filter(t => Number(t.payment_amount || t.amount || 0) > 0)
    .sort((a, b) => new Date(b.payment_datetime || b.payment_date || 0) -
                    new Date(a.payment_datetime || a.payment_date || 0))[0];
  const billNoRaw = billNoSource || latestPayment?.payment_id || '';
  const billNoFormatted = billNoRaw ? String(billNoRaw).padStart(6, '0') : 'N/A';

  const dischargeRaw = data.ipd_discharge_datetime || data.discharge_datetime ||
                       data.ipd_row?.discharge_datetime || '';
  const validDischarge = dischargeRaw &&
    dischargeRaw !== '0000-00-00 00:00:00' &&
    String(dischargeRaw).toLowerCase() !== 'null';
  const dischargeDateStr = validDischarge ? formatDateTime12h(dischargeRaw) : formatDateTime12h(new Date());

  // ===== PATIENT / BILL HEADER TABLE =====
  autoTable(doc, {
    startY: y,
    body: [[
      `UHID No : ${uhidVal}\n` +
      `Patient : ${data.ipd_bill_patient_name || ''}\n` +
      `Age/Gender : ${data.ipd_bill_patient_age || ''} / ${data.ipd_bill_patient_gender || ''}\n` +
      `Address : ${data.ipd_bill_patient_address || ''}\n` +
      `Referred Doctor : ${getDoctorNameById(data.ipd_bill_refered_doctor) || ''}\n` +
      `Insurance : ${data.ipd_policy_name || 'N/A'}\n`,

      `Bill No : ${billNoFormatted}\n` +
      `IPD No : ${data.ipd_display_no || data.ipd_no || ''}\n` +
      `Admission Date : ${formatDateTime12h(data.ipd_bill_doa)}\n` +
      `Billing Date : ${formatDateTime12h(data.ipd_bill_date)}\n` +
      `Discharge Date : ${dischargeDateStr}\n` +
      `Bed : ${getBedNameById(data.ipd_bill_bed) || ''}\n` +
      `Ward : ${getWardNameById(data.ipd_bill_ward) || ''}\n`,
    ]],
    theme: 'grid',
    styles: { fontSize: 10, cellPadding: 2, lineColor: [0,0,0], textColor: [0,0,0], lineWidth: 0.3 },
    columnStyles: { 0: { cellWidth: 110 }, 1: { cellWidth: 70 } },
    didDrawCell: (dt) => {
      try {
        if (dt.section === 'body' && dt.column.index === 0 && dt.row.index === 0 && barcodeDataUrl) {
          doc.addImage(barcodeDataUrl, 'PNG', dt.cell.x + 73, dt.cell.y + 2, 34, 7);
        }
      } catch (e) { /* ignore */ }
    }
  });
  y = doc.lastAutoTable.finalY + 3;

  // ===== PHARMACY =====
  if (includePharmacy && pharmacyFinal > 0) {
    autoTable(doc, {
      startY: y + 3,
      head: [['Pharmacy Details']],
      body: [[{ content: `Total Amount: ${pharmacyFinal.toFixed(2)}`, styles: { halign: 'left' } }]],
      theme: 'grid',
      headStyles: { fillColor: headerColor, textColor: 0, fontStyle: 'bold', halign: 'left' },
      styles: { fontSize: 9, cellPadding: 1.5, lineColor: [0,0,0], lineWidth: 0.1 }
    });
    y = doc.lastAutoTable.finalY + 6;
  }

  // ===== IPD PAYMENT HISTORY (advance rows + payments) =====
  const advanceRows = (advanceHistory || []).map(a => {
    const dt = String(a.payment_date || '');
    let name = a.received_by_name || a.received_by || '';
    name = String(name).replace(/^User #/, '');
    return {
      payment_id: `ADV-${a.advance_id}`,
      payment_datetime: dt,
      payment_date: dt.split(' ')[0] || dt,
      payment_amount: a.advance_amount,
      payment_type: 'Advance',
      payment_method: a.payment_type || 'Cash',
      received_by_name: name,
      is_advance: true,
    };
  });
  const combinedTransactions = [...advanceRows, ...transactions];

  doc.setFontSize(10).setFont('helvetica', 'bold');
  doc.text('IPD Payment History', 14, y + 2);

  const txnData = combinedTransactions.length
    ? combinedTransactions.map((item, index) => {
        const amt = parseFloat(item.payment_amount || item.amount || 0);
        const type = String(item.payment_type || '').toLowerCase();
        const isReturn = amt < 0 || type.includes('return') || type.includes('refund');
        const isAdvance = item.is_advance === true || type === 'advance';

        let amountCell;
        if (isReturn) amountCell = `REFUND: ${Math.abs(amt).toFixed(2)}`;
        else if (isAdvance) amountCell = `Advance: ${amt.toFixed(2)}`;
        else amountCell = amt.toFixed(2);

        const personName = (item.received_by_name && String(item.received_by_name).trim() !== '')
          ? item.received_by_name
          : `User #${item.received_by || item.collected_by || ''}`;

        return [
          index + 1,
          formatDateTime12h(item.payment_datetime || item.payment_date),
          amountCell,
          item.payment_method || 'Cash',
          isReturn ? `Refund By: ${personName}` : personName,
          isReturn
        ];
      })
    : [['', 'No Record Found', '', '', '', false]];

  autoTable(doc, {
    startY: y + 4,
    head: [['Sl.No', 'Date', 'Amount', 'Payment Method', 'Received By']],
    body: txnData.map(r => r.slice(0, 5)),
    theme: 'grid',
    headStyles: { fillColor: headerColor, textColor: 0, fontStyle: 'bold' },
    styles: { fontSize: 9, cellPadding: 1.5, textColor: 0, lineColor: [0,0,0], lineWidth: 0.2 },
    didParseCell: (d) => {
      if (d.section === 'body' && txnData[d.row.index] && txnData[d.row.index][5] === true) {
        d.cell.styles.textColor = [220, 53, 69];
        d.cell.styles.fontStyle = 'bold';
      }
    }
  });
  y = doc.lastAutoTable.finalY + 9;

  // ===== IPD SERVICES (+ INVESTIGATION) =====
  ensureSpace(30);
  doc.setFontSize(10).setFont('helvetica', 'bold');
  doc.text('IPD Services', 14, y);

  const ipdData = otitems.length
    ? otitems.map((item, index) => [
        index + 1,
        item.ipd_bill_item_service || item.service || item.name || 'N/A',
        Number(item.ipd_bill_item_qty ?? item.qty ?? 1) || 1,
        Number(item.ipd_bill_item_charge ?? item.charge ?? 0).toFixed(2),
        Number(item.ipd_bill_item_dis ?? item.discount ?? 0).toFixed(2),
        Number(item.ipd_bill_item_final ?? item.amount ?? 0).toFixed(2),
      ])
    : [['', 'No items', '', '', '', '']];

  const investigationRows = buildInvestigationRowsFrom(labRecords, labDetails);

  if (includeLab && labFinal > 0 && investigationRows.length > 0) {
    ipdData.push([{
      content: 'Investigation',
      colSpan: 6,
      styles: { fillColor: headerColor, textColor: 0, fontStyle: 'bold', halign: 'left' }
    }]);

    investigationRows.forEach((row, i) => {
      ipdData.push([
        i + 1,
        row.name,
        row.qty,
        Number(row.unit || 0).toFixed(2),
        Number(row.discount || 0).toFixed(2),
        Number(row.final || 0).toFixed(2),
      ]);
    });

    const invGross = investigationRows.reduce((s, r) => s + Number(r.final || 0), 0);
    const invDisc = Math.max(0, invGross - labFinal);
    if (invDisc > 0) {
      ipdData.push([
        { content: 'Discount', colSpan: 5, styles: { halign: 'right', fontStyle: 'bold' } },
        { content: invDisc.toFixed(2), styles: { halign: 'right', fontStyle: 'bold' } },
      ]);
    }
  }

  autoTable(doc, {
    startY: y + 2,
    head: [['Sl.No', 'Particular of Services', 'Qty', 'Amount', 'Discount', 'Final Amount']],
    body: ipdData,
    theme: 'grid',
    headStyles: { fillColor: headerColor, textColor: 0, fontStyle: 'bold' },
    styles: { fontSize: 9, cellPadding: 1.5, textColor: 0, lineColor: 0, lineWidth: 0.2 },
    columnStyles: {
      0: { halign: 'center' }, 2: { halign: 'center' },
      3: { halign: 'right' }, 4: { halign: 'right' }, 5: { halign: 'right' }
    }
  });
  y = doc.lastAutoTable.finalY + 8;

  // ===== SUMMARY =====
  ensureSpace(70);
  doc.setFontSize(10).setFont('helvetica', 'normal');
  const labelX = 140, rightX = 190;

  const total = Number(data.ipd_bill_total_amt || 0);
  const discountPercent = Number(data.ipd_bill_discount || 0);
  const discountAmount = Number(data.ipd_bill_fixed_deposit || 0) || (total * discountPercent / 100);
  const finalAmt = Number(data.ipd_bill_final_amt || 0);
  const adv = Number(data.ipd_bill_adv_amount || 0);

  const labInSummary = includeLab && labFinal > 0;
  const labFinalForSummary = labInSummary ? labFinal : 0;

  if (discountAmount > 0) {
    doc.text('Discount Amt :', labelX, y);
    doc.text(discountAmount.toFixed(2), rightX, y, { align: 'right' }); y += 6;
  }

  doc.text('Final Amount :', labelX, y);
  doc.text((finalAmt + labFinalForSummary).toFixed(2), rightX, y, { align: 'right' }); y += 6;

  doc.text('IPD Advance :', labelX, y);
  doc.text(adv.toFixed(2), rightX, y, { align: 'right' }); y += 6;

  const positiveTxns = transactions.filter(t => {
    const amt = Number(t.payment_amount || t.amount || 0);
    const type = String(t.payment_type || '').toLowerCase();
    return amt > 0 && !type.includes('return') && !type.includes('refund');
  });
  const txnPositiveSum = positiveTxns.reduce((s, t) => s + Number(t.payment_amount || t.amount || 0), 0);
  const totalPaid = adv + txnPositiveSum;

  const actualRefund = (returnHistory || []).reduce((s, r) => s + Number(r.return_amount || 0), 0);
  const rawExcess = totalPaid - finalAmt;
  const displayDue = rawExcess < 0 ? Math.abs(rawExcess) : 0;

  if (displayDue > 0) {
    doc.text('IPD Due :', labelX, y);
    doc.text(displayDue.toFixed(2), rightX, y, { align: 'right' }); y += 6;
  }

  if (labDue > 0) {
    doc.setFont('helvetica', 'bold');
    doc.text('Total Due :', labelX, y);
    doc.text((displayDue + labDue).toFixed(2), rightX, y, { align: 'right' });
    doc.setFont('helvetica', 'normal'); y += 6;
  }

  if (labInSummary) {
    doc.setFont('helvetica', 'bold');
    doc.text('Total Paid :', labelX, y);
    doc.text((totalPaid + labPaid).toFixed(2), rightX, y, { align: 'right' });
    doc.setFont('helvetica', 'normal'); y += 6;

    if (labDue > 0) {
      doc.setTextColor(220, 53, 69);
      doc.text('Lab Due :', labelX, y);
      doc.text(labDue.toFixed(2), rightX, y, { align: 'right' });
      doc.setTextColor(0, 0, 0); y += 6;
    }
  }

  if (actualRefund > 0) {
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(220, 53, 69);
    doc.text('Return / Refund :', labelX, y);
    doc.text(`- ${actualRefund.toFixed(2)}`, rightX, y, { align: 'right' }); y += 6;

    doc.setTextColor(25, 135, 84);
    doc.text('Net Paid :', labelX, y);
    doc.text((totalPaid - actualRefund).toFixed(2), rightX, y, { align: 'right' });
    doc.setTextColor(0, 0, 0);
    doc.setFont('helvetica', 'normal'); y += 6;

    const labFromAdv = (returnHistory || []).reduce((s, r) => s + Number(r.lab_paid_from_advance || 0), 0);
    if (labFromAdv > 0) {
      doc.text('Lab Paid from Advance :', labelX, y);
      doc.text(labFromAdv.toFixed(2), rightX, y, { align: 'right' }); y += 6;
    }
    const pharmaFromAdv = (returnHistory || []).reduce((s, r) => s + Number(r.pharmacy_paid_from_advance || 0), 0);
    if (pharmaFromAdv > 0) {
      doc.text('Pharmacy Paid from Advance :', labelX, y);
      doc.text(pharmaFromAdv.toFixed(2), rightX, y, { align: 'right' }); y += 6;
    }
  }

  y += 2;

  // ===== AMOUNT IN WORDS =====
  ensureSpace(14);
  doc.setFontSize(9).setFont('helvetica', 'bold');
  const wordsBase = labInSummary
    ? (labFinal + (includePharmacy ? pharmacyFinal : 0) + finalAmt)
    : finalAmt;
  doc.text(`AMOUNT IN WORDS : ${(amountInWords(wordsBase || 0) + ' only').toUpperCase()}`, 14, y);

  // ===== INVESTIGATION PAYMENT HISTORY =====
  if (includeLab && labFinal > 0) {
    const labPayRows = [];
    (labRecords || []).forEach(rec => {
      const det = labDetails[rec.lab_reg_id] || {};
      (det.payments || []).forEach(p => {
        labPayRows.push([
          labPayRows.length + 1,
          formatDateTime12h(p.payment_datetime || p.payment_date),
          Number(p.payment_amount || 0).toFixed(2),
          p.payment_mode || 'Cash',
          p.payment_received_by || p.received_by_name || p.received_by || ''
        ]);
      });
    });

    if (labPayRows.length > 0) {
      y += 8;
      ensureSpace(30);
      doc.setFontSize(10).setFont('helvetica', 'bold');
      doc.text('Investigation Payment History', 14, y);
      autoTable(doc, {
        startY: y + 3,
        head: [['Sl.No', 'Date', 'Amount', 'Mode', 'Received By']],
        body: labPayRows,
        theme: 'grid',
        headStyles: { fillColor: headerColor, textColor: 0, fontStyle: 'bold' },
        styles: { fontSize: 9, cellPadding: 1.5, textColor: 0, lineColor: 0, lineWidth: 0.2 },
        columnStyles: { 0: { halign: 'center' }, 2: { halign: 'right' } }
      });
      y = doc.lastAutoTable.finalY + 6;
    }
  }

  // ===== EXCESS AMOUNT USAGES =====
  if (advanceUsage && advanceUsage.length > 0) {
    y += 8;
    ensureSpace(30);
    doc.setFontSize(10).setFont('helvetica', 'bold');
    doc.text('Excess Amount Usages', 14, y);

    const usageData = advanceUsage.map((u, i) => [
      i + 1,
      formatDateTime12h(u.usage_datetime || u.usage_date || u.created_at),
      u.usage_type || u.usage_for || u.purpose || 'Advance Adjustment',
      u.ipd_bill_id || u.bill_id || '-',
      Number(u.usage_amount || 0).toFixed(2),
    ]);
    usageData.push(['', '', '', 'TOTAL:', advanceUsedTotal.toFixed(2)]);

    autoTable(doc, {
      startY: y + 3,
      head: [['S.No', 'Date', 'Purpose', 'Bill ID', 'Amount']],
      body: usageData,
      theme: 'grid',
      headStyles: { fillColor: headerColor, textColor: 0, fontStyle: 'bold' },
      styles: { fontSize: 9, cellPadding: 1.5, textColor: 0, lineColor: 0, lineWidth: 0.2 },
      columnStyles: { 0: { halign: 'center', cellWidth: 20 }, 4: { halign: 'right' } },
      didParseCell: (d) => {
        if (d.row.index === usageData.length - 1) d.cell.styles.fontStyle = 'bold';
      }
    });
    y = doc.lastAutoTable.finalY + 6;
  }

  // ===== FOOTER =====
  ensureSpace(50);
  const footerY = y + 20;
  try {
    const qrText = `UHID: ${uhidVal}, Name: ${data.ipd_bill_patient_name || ''}`;
    const qrCodeDataURL = await QRCode.toDataURL(qrText, { width: 100 });
    doc.addImage(qrCodeDataURL, 'PNG', 14, footerY, 19, 19);
  } catch (e) { /* ignore */ }

  doc.setFontSize(9).setFont('helvetica', 'normal');
  if (transactions.length > 0) {
    const latest = transactions[transactions.length - 1];
    const name = (latest.received_by_name && String(latest.received_by_name).trim() !== '')
      ? latest.received_by_name
      : String(latest.received_by || '');
    doc.text(`Prepared By: ${name}`, 14, footerY + 25);
  }

  doc.setFontSize(9).setFont('helvetica', 'bold');
  doc.text('Authorised Signature', pageWidth - 50, footerY + 25);
  doc.line(pageWidth - 70, footerY + 20, pageWidth - 15, footerY + 20);

  window.open(doc.output('bloburl'), '_blank');
};


/* ============================================================
 *  PRINT HANDLER — options dialog + gathers everything
 * ============================================================ */
const handlePrintFinalBill = async (row) => {
  const uhid   = row.ipd_bill_uhid || '';
  const ipdNo  = row.ipd_no || '';
  const billId = row.ipd_bill_id || '';

  Swal.fire({ title: 'Loading bill...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });

  let payments = [], labData = { records: [], detailsMap: {}, final: 0, paid: 0, due: 0 };
  let pharmacyFinal = 0, advInfo = { history: [], usage: [], usedTotal: 0, billNoSource: null };
  let returns = [], items = [];

  try {
    // payments (by numeric ipd_no, as the backend expects)
    if (ipdNo && /^\d+$/.test(String(ipdNo))) {
      try {
        const fd = new FormData();
        fd.append('ipd_no', String(ipdNo));
        const resp = await axios.post(
          AppConst.BASE_URL + AppConst.GetPaymentIpdBill, fd,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        if (resp?.data?.status && Array.isArray(resp.data.history)) payments = resp.data.history;
        if (resp?.data?.bill_no_source) advInfo.billNoSource = resp.data.bill_no_source;
      } catch (e) { console.warn('payment fetch failed', e); }
    }

    // pharmacy total (lab figures come from the lab fetch below, per admission)
    if (uhid) {
      try {
        const fd = new FormData();
        fd.append('uhid', uhid);
        const dueRes = await axios.post(AppConst.BASE_URL + AppConst.checkUhidDueCall, fd);
        if (dueRes?.data?.status) {
          pharmacyFinal = Number(dueRes.data.dues?.pharmacy?.final || 0);
        }
      } catch (e) { console.warn('due fetch failed', e); }
    }

    const [ld, ai, rh, it] = await Promise.all([
      fetchLabDataForBill(ipdNo),
      fetchAdvanceInfo(uhid),
      fetchReturnHistoryFor(uhid),
      fetchBillItemsFor({ uhid, ipdNo, billId }),
    ]);
    labData = ld;
    advInfo = { ...ai, billNoSource: ai.billNoSource || advInfo.billNoSource };
    returns = rh;
    items = (row.items || row.ipd_bill_items || row.otitems || []);
    if (!items.length) items = it;

    setTransactionHistory(payments);
    setFinalPayment(labData.final);
  } finally {
    Swal.close();
  }

  // ===== print options (same dialog as IPD Billing) =====
  const { value: formValues, isConfirmed } = await Swal.fire({
    title: 'IPD Bill Print Options',
    html: `
      <div style="text-align:left;padding:10px;">
        <div style="margin-bottom:15px;">
          <label style="display:flex;align-items:center;cursor:pointer;">
            <input type="checkbox" id="includeHeader" checked style="margin-right:10px;width:18px;height:18px;">
            <span><strong>Include Header Image</strong></span>
          </label>
          <small style="margin-left:28px;color:#666;">Hospital logo and header</small>
        </div>
        <div style="margin-bottom:15px;">
          <label style="display:flex;align-items:center;cursor:pointer;">
            <input type="checkbox" id="includeLab" ${labData.final > 0 ? 'checked' : ''} ${labData.final === 0 ? 'disabled' : ''}
              style="margin-right:10px;width:18px;height:18px;">
            <span><strong>Include Lab Details</strong></span>
          </label>
          <small style="margin-left:28px;color:#666;">
            ${labData.final > 0
              ? `Total: ₹${labData.final.toFixed(2)}, Due: ₹${labData.due.toFixed(2)}${labData.records.length > 1 ? ` (${labData.records.length} records)` : ''}`
              : 'No lab billing found'}
          </small>
        </div>
        <div style="margin-bottom:15px;">
          <label style="display:flex;align-items:center;cursor:pointer;">
            <input type="checkbox" id="includePharmacy" ${pharmacyFinal > 0 ? 'checked' : ''} ${pharmacyFinal === 0 ? 'disabled' : ''}
              style="margin-right:10px;width:18px;height:18px;">
            <span><strong>Include Pharmacy Details</strong></span>
          </label>
          <small style="margin-left:28px;color:#666;">
            ${pharmacyFinal > 0 ? `Amount: ₹${pharmacyFinal.toFixed(2)}` : 'No pharmacy billing found'}
          </small>
        </div>
      </div>
    `,
    focusConfirm: false,
    showCancelButton: true,
    confirmButtonText: 'Print',
    cancelButtonText: 'Cancel',
    width: 500,
    preConfirm: () => ({
      includeHeader: document.getElementById('includeHeader').checked,
      includeLab: document.getElementById('includeLab').checked,
      includePharmacy: document.getElementById('includePharmacy').checked,
    })
  });

  if (!isConfirmed || !formValues) return;

  const enriched = {
    ...row,
    ipd_discharge_datetime:
      row.ipd_row?.discharge_datetime || row.discharge_datetime || row.ipd_bill_ot || '',
  };

  await generatePDF(enriched, formValues, {
    transactions: payments,
    items,
    labRecords: labData.records,
    labDetails: labData.detailsMap,
    labFinal: labData.final,
    labPaid: labData.paid,
    labDue: labData.due,
    pharmacyFinal,
    advanceHistory: advInfo.history,
    advanceUsage: advInfo.usage,
    advanceUsedTotal: advInfo.usedTotal,
    returnHistory: returns,
    billNoSource: advInfo.billNoSource,
  });
};



  // ----------------- other PDF variants kept but simplified -----------------
  const generateProvisionalBill = async (formDataLocal) => {
    // Keep your existing provisional PDF logic; for brevity call the same generatePDF if you want.
    // Here we'll create a simple provisional by reusing generatePDF (you can replace with your more complex implementation)
    await generatePDF(formDataLocal);
  };

  const generateGatePass = (item) => {
    const win = window.open('', '_blank', 'width=800,height=900');
    if (!win) {
      Swal.fire("Popup blocked", "Please allow popups to print the gate pass.", "warning");
      return;
    }
  
    // safe bed/ward lookup: prefer ward list lookup, then fallback to item fields
    const bedName = getBedNameById(item.ipd_bill_bed) || item.bed_name || item.ipd_bill_bed || '';
    const wardName = getWardNameById(item.ipd_bill_ward) || item.ward_name || item.ipd_bill_ward || '';
  
    const html = `
      <html>
      <head><title>Gate Pass - ${escapeHtml(item.ipd_bill_patient_name || '')}</title>
      <style>
        body { font-family: Arial, sans-serif; padding: 20px; color: #222; }
        .card { border: 1px solid #ddd; padding: 18px; border-radius: 6px; max-width:700px; }
        h1 { font-size: 20px; margin-bottom: 6px; }
        .row { display:flex; gap:12px; margin-bottom:8px; align-items:center; }
        .label { font-weight:600; width:150px; }
        .value { flex:1; word-break:break-word; }
        .note { margin-top:18px; font-size:12px; color:#666;}
        .small { font-size:13px; color:#333; }
      </style>
      </head>
      <body>
      <div class="card">
        <h1>Gate Pass</h1>
        <div class="row"><div class="label">Patient Name:</div><div class="value">${escapeHtml(item.ipd_bill_patient_name || '')}</div></div>
        <div class="row"><div class="label">UHID</div><div class="value">${escapeHtml(item.ipd_bill_uhid || item.ipd_no || '')}</div></div>
        <div class="row"><div class="label">IPD No</div><div class="value">${escapeHtml(item.ipd_display_no||item.ipd_no || '')}</div></div>
        <div class="row"><div class="label">Bed:</div><div class="value">${escapeHtml(bedName)}</div></div>
        <div class="row"><div class="label">Ward:</div><div class="value">${escapeHtml(wardName)}</div></div>
        <div class="row"><div class="label">Final Bill:</div><div class="value">₹${Number(item.ipd_bill_final_amt || item.lab_final_amount || 0).toFixed(2)}</div></div>
        <div class="row"><div class="label">Paid:</div><div class="value">₹${Number(item.ipd_bill_paid || item.ipd_paid || 0).toFixed(2)}</div></div>
        <div class="row"><div class="label">Due:</div><div class="value">₹${Number(item.ipd_bill_due || item.ipd_due || 0).toFixed(2)}</div></div>
        <div class="note printed-at small">Printed at: ${new Date().toLocaleString()}</div>
      </div>
      <script>
        // auto-print and close optional
        setTimeout(()=>{ window.print(); }, 300);
      </script>
      </body></html>
    `;
    win.document.open();
    win.document.write(html);
    win.document.close();
  };
  

  // ----------------- data fetch/init logic -----------------


  
  const initData = async (overrides = {}) => {
    // keep stored info
    const stored = sessionStorage.getItem("ldata");
    if (stored) {
      try { setLdata(JSON.parse(stored)); } catch { /* ignore */ }
    }

    const page_no = overrides.page_no !== undefined ? overrides.page_no : formData.page_no;
    const search_key = (overrides.search_key !== undefined) ? overrides.search_key : formData.search_key;
    const from = (overrides.from !== undefined) ? overrides.from : formData.from;
    const to = (overrides.to !== undefined) ? overrides.to : formData.to;

    const effectiveFrom = from && String(from).trim() !== '' ? from : getTodayStr();
    const effectiveTo   = to && String(to).trim() !== '' ? to : getTodayStr();

    const fd = new FormData();
    fd.append('page_no', String(page_no));
    fd.append('search_key', String(search_key));
    if (effectiveFrom) fd.append('from', effectiveFrom);
    if (effectiveTo) fd.append('to', effectiveTo);
    fd.append('status', '1');

    setLoading(true);
    try {
      const res = await axios.post(AppConst.BASE_URL + AppConst.getIpdBillListUrl, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      // success + array records -> use them
      if (res && res.data && res.data.status && Array.isArray(res.data.records)) {
        const records = res.data.records || [];
        setFormData(prev => ({ ...prev, l1: records, page_no: page_no, search_key: search_key }));
        setCachedList(records); // update cached server list
        return;
      }

      // server returned no array records
      if (search_key && String(search_key).trim() !== '') {
        // fallback: use cachedList to produce a filtered client-side list so UHID/name matches remain visible
        const fallback = filterClientBySearch(cachedList.length ? cachedList : (formData.l1 || []), search_key, effectiveFrom, effectiveTo);
        if (fallback && fallback.length) {
          setFormData(prev => ({ ...prev, l1: fallback, page_no: page_no, search_key: search_key }));
          return;
        }
        // if fallback empty, DO NOT clear the list abruptly; keep existing formData.l1
        setFormData(prev => ({ ...prev, page_no: page_no, search_key: search_key }));
        return;
      }

      // no search key -> safe to clear list (server says empty)
      setFormData(prev => ({ ...prev, l1: [] , page_no: page_no, search_key: search_key }));
    } catch (err) {
      console.error("initData error", err);
      toast.error("Error fetching list");
      // on network error, keep existing list to avoid flicker
    } finally {
      setLoading(false);
    }
  };


  const initStaticData = async () => {
    // wards
    const fdW = new FormData();
    fdW.append('par_by', '1');
    try {
      const r = await axios.post(AppConst.BASE_URL + AppConst.getBedListUrl1, fdW, { headers: { 'Content-Type': 'multipart/form-data' }});
      if (r?.data?.status) setFormData(prev => ({ ...prev, wards: r.data.records || [] }));
    } catch (e) { console.error(e); }

    // doctors
    const fdD = new FormData();
    fdD.append('type', 'doctor');
    fdD.append('search_key', '');
    fdD.append('page_no', 'none');
    fdD.append('user_cre_by', '1');
    try {
      const r2 = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fdD, { headers: { 'Content-Type': 'multipart/form-data' }});
      if (r2?.data?.status) setFormData(prev => ({ ...prev, doc: r2.data.records || [] }));
    } catch (e) { console.error(e); }
  };

  useEffect(() => {
    const stored = sessionStorage.getItem("ldata");
    if (stored) setLdata(JSON.parse(stored));
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    const todayStr = `${yyyy}-${mm}-${dd}`;
    setFormData(prev => ({ ...prev, from: todayStr, to: todayStr }));
    initData({ from: todayStr, to: todayStr });
    initStaticData();
    fetchConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (formData.from === "" && formData.to === "") {
      const t = getTodayStr();
      initData({ from: t, to: t });
    } else {
      initData({ from: formData.from, to: formData.to, search_key: formData.search_key });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.from, formData.to]);


  const fetchConfig = async () => {
    try {
      const res = await axios.post(`${AppConst.BASE_URL + AppConst.getconfig}?config_type=lab`);
      if (res?.data?.status) {
        setImage(res.data.header_logo || '');
      }
    } catch (e) {
      console.error(e);
    }
  };

  // ----------------- search handlers -----------------
    // Use getTodayStr() helper (already in your file)



   const handleSearchInputChange = (value) => {
  // update the text immediately so filteredRows re-filters live
  setFormData(prev => ({ ...prev, search_key: value }));

  // debounce the authoritative server call
  if (searchTimer.current) { clearTimeout(searchTimer.current); searchTimer.current = null; }

  searchTimer.current = setTimeout(() => {
    if (value && value.trim() !== '') {
      // searching → no date filter
      initData({ from: '', to: '', search_key: value, page_no: 0 });
    } else {
      // cleared → restore today's list
      const t = getTodayStr();
      initData({ from: t, to: t, search_key: '', page_no: 0 });
    }
    searchTimer.current = null;
  }, DEBOUNCE_MS);
};
  
      const doImmediateSearch = () => {
    if (searchTimer.current) {
      clearTimeout(searchTimer.current);
      searchTimer.current = null;
    }
    setFormData(prev => {
      const fromVal = prev.from && prev.from !== '' ? prev.from : getTodayStr();
      const toVal = prev.to && prev.to !== '' ? prev.to : getTodayStr();
      initData({ from: fromVal, to: toVal, search_key: prev.search_key || '', page_no: 0 });
      return prev;
    });
  };

  

  useEffect(() => () => {
    if (searchTimer.current) {
      clearTimeout(searchTimer.current);
      searchTimer.current = null;
    }
  }, []);

  const handleSearch = () => initData({ from: formData.from, to: formData.to, search_key: formData.search_key, page_no: 0 });

  const handleClear = () => {
    if (searchTimer.current) { clearTimeout(searchTimer.current); searchTimer.current = null; }

    // compute today's date string locally to avoid "todayStr is not defined" errors
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    const todayStr = `${yyyy}-${mm}-${dd}`;

    setFormData(prev => ({ ...prev, search_key: "", from: todayStr, to: todayStr, page_no: 0 }));
    initData({ from: todayStr, to: todayStr, search_key: "" });
  };
    // helper to return YYYY-MM-DD for today
    const getTodayStr = () => {
      const t = new Date();
      return `${t.getFullYear()}-${String(t.getMonth()+1).padStart(2,'0')}-${String(t.getDate()).padStart(2,'0')}`;
    };
  
    const filterClientBySearch = (list, searchKey, fromStr, toStr) => {
      const rawQ = (searchKey || '').toString().trim().toLowerCase();
      const norm = (s) => (s === null || s === undefined) ? '' : String(s).toLowerCase().replace(/[^a-z0-9]/g, '');
      const numericFromQ = (rawQ.match(/\d+/) || [''])[0];
  
      let fromDt = null, toDt = null;
      if (fromStr) {
        const p = fromStr.split('-');
        fromDt = new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]));
      }
      if (toStr) {
        const p = toStr.split('-');
        toDt = new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]), 23, 59, 59);
      }
  
      return (list || []).filter(row => {
        const s = row.status ?? row.ipd_status ?? row.ipd_bill_status ?? row.bill_status ?? null;
        if (s === null || String(s) !== '1') return false;
  
        // date filter
        const raw = row.ipd_row?.discharge_datetime ?? row.ipd_bill_ot ?? row.ipd_bill_datetime ?? row.ipd_bill_date ?? null;
        const dt = parseServerDate(raw);
        if (fromDt && toDt) {
          if (!dt || isNaN(dt.getTime())) return false;
          if (dt.getTime() < fromDt.getTime() || dt.getTime() > toDt.getTime()) return false;
        }
  
        if (!rawQ) return true; // include when search empty
  
        const qNorm = norm(rawQ);
        const uhidRaw = norm(row.ipd_bill_uhid || '');
        const ipdNo = row.ipd_no !== undefined && row.ipd_no !== null ? String(row.ipd_no) : '';
        const ipdNoNorm = norm(ipdNo);
        const paddedIpdNo = ipdNo ? ipdNo.padStart(3, '0') : '';
        const paddedIpdNoNorm = norm(paddedIpdNo);
        const nameNorm = norm(row.ipd_bill_patient_name || '');
  
        const anyMatch =
          (uhidRaw && uhidRaw.includes(qNorm)) ||
          (ipdNoNorm && (ipdNoNorm === qNorm || ipdNoNorm.includes(qNorm))) ||
          (paddedIpdNoNorm && (paddedIpdNoNorm === qNorm || paddedIpdNoNorm.includes(qNorm))) ||
          (numericFromQ && ipdNo && ipdNo === numericFromQ) ||
          (nameNorm && nameNorm.includes(qNorm));
  
        return Boolean(anyMatch);
      });
    };
  
    const filteredRows = useMemo(() => {
      const list = formData.l1 || [];
      const fromStr = formData.from || '';
      const toStr = formData.to || '';
      const rawQ = (formData.search_key || '').toString().trim().toLowerCase();
  
      // helper normalizer: remove non-alphanum and lowercase
      const norm = (s) => (s === null || s === undefined) ? '' : String(s).toLowerCase().replace(/[^a-z0-9]/g, '');
  
      // try to parse numeric part from query (useful for ipd_no)
      const numericFromQ = (rawQ.match(/\d+/) || [''])[0];
  
      let fromDt = null, toDt = null;
      if (fromStr) {
        const p = fromStr.split('-');
        fromDt = new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]));
      }
      if (toStr) {
        const p = toStr.split('-');
        toDt = new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]), 23, 59, 59);
      }
  
    return list.filter(row => {
      const s = row.status ?? row.ipd_status ?? row.ipd_bill_status ?? row.bill_status ?? null;
      if (s === null || String(s) !== '1') return false;

      // ✅ Date filter ONLY when there is no search term
      if (!rawQ && fromDt && toDt) {
        const raw = row.ipd_row?.discharge_datetime ?? row.ipd_bill_ot ?? row.ipd_bill_datetime ?? row.ipd_bill_date ?? null;
        const dt = parseServerDate(raw);
        if (!dt || isNaN(dt.getTime())) return false;
        if (dt.getTime() < fromDt.getTime() || dt.getTime() > toDt.getTime()) return false;
      }

      // Search: if empty, include
      if (!rawQ) return true;
  
        const qNorm = norm(rawQ);
        const uhidRaw = norm(row.ipd_bill_uhid || '');
        const ipdNo = row.ipd_no !== undefined && row.ipd_no !== null ? String(row.ipd_no) : '';
        const ipdNoNorm = norm(ipdNo);
        // padded ipd no with three leading zeros used in UI (e.g. 00012)
        const paddedIpdNo = ipdNo ? ipdNo.padStart(3, '0') : '';
        const paddedIpdNoNorm = norm(paddedIpdNo);
        // variants to compare
        const nameNorm = norm(row.ipd_bill_patient_name || '');
        const anyMatch =
          (uhidRaw && uhidRaw.includes(qNorm)) ||
          (ipdNoNorm && (ipdNoNorm === qNorm || ipdNoNorm.includes(qNorm))) ||
          (paddedIpdNoNorm && (paddedIpdNoNorm === qNorm || paddedIpdNoNorm.includes(qNorm))) ||
          (numericFromQ && ipdNo && ipdNo === numericFromQ) || // if user typed only digits
          (nameNorm && nameNorm.includes(qNorm));
  
        return Boolean(anyMatch);
      });
    }, [formData.l1, formData.from, formData.to, formData.search_key]);
  


  // ----------------- move to IPD -----------------
  const handleMoveToIpd = async (row) => {
    const { value: reason } = await Swal.fire({
      title: 'Move to IPD',
      text: 'Move this bill back to IPD (activate)?',
      input: 'text',
      inputLabel: 'Reason (optional)',
      inputPlaceholder: 'Enter reason (optional)',
      showCancelButton: true,
      confirmButtonText: 'Yes, move to IPD',
      cancelButtonText: 'Cancel'
    });
    if (reason === undefined) return;
    const fd = new FormData();
    if (row.ipd_bill_id) fd.append('ipd_bill_id', String(row.ipd_bill_id));
    if (row.ipd_bill_uhid) fd.append('ipd_bill_uhid', String(row.ipd_bill_uhid));
    fd.append('status', '0');
    fd.append('reason', (reason || '') + '');
    try {
      const res = await axios.post(AppConst.BASE_URL + AppConst.UpdateIpdStatusBoth2, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (!(res?.data?.status)) {
        Swal.fire('Error', (res.data && res.data.success) || 'Failed to update status', 'error');
        return;
      }
      // remove from displayed list
      setFormData(prev => ({ ...prev, l1: (prev.l1 || []).filter(r => String(r.ipd_bill_id) !== String(row.ipd_bill_id)) }));
      toast.success(res.data.success || 'Moved to IPD');
    } catch (err) {
      console.error('Move to IPD error', err);
      const isNetworkError = !err.response;
      if (isNetworkError) Swal.fire('Error', 'Server error while updating status', 'error');
      else Swal.fire('Error', (err.response?.data?.success) || 'Failed to update status', 'error');
    }
  };

  // ----------------- DataTable columns -----------------
  const columns = useMemo(() => [
    { name: 'SN', selector: (row, i) => i+1, width: '60px' },
    { name: 'UHID', selector: row => row.ipd_bill_uhid || '' , sortable: true, width: '150px' },
    {
      name: 'IPD No',
      selector: row => row.ipd_no || '',
      cell: row => {
        return row.ipd_display_no || `000${row.ipd_no || ''}`;
      },
      sortable: true,
      width: '100px'
    },
    { name: 'Patient', selector: row => row.ipd_bill_patient_name || '', sortable: true, width: '200px' },
    { name: 'Bed', selector: row => getBedNameById(row.ipd_bill_bed) || 'N/A' },
    { name: 'Referred By', selector: row => getDoctorNameById(row.ipd_bill_refered_doctor) || '', width: '230px' },
    { name: 'Contact', selector: row => row.ipd_bill_patient_phone || '' , width: '150px'},
    {
      name: 'Admission Date',
      selector: row => {
        const dt = parseServerDate(row.ipd_bill_doa);
        return dt ? dt.getTime() : 0;
      },
      cell: row => {
        const dt = parseServerDate(row.ipd_bill_doa);
        return dt ? formatDateTime12h(dt) : '';
      },
      sortable: true,
      width: '200px'
    },
    {
      name: 'Discharge Date/Time',
      selector: row => {
        const dtRaw = row.ipd_row?.discharge_datetime ?? row.ipd_bill_ot ?? row.ipd_bill_datetime ?? null;
        const dt = parseServerDate(dtRaw);
        return dt ? dt.getTime() : 0;
      },
      cell: row => {
        const dt = parseServerDate(row.ipd_row?.discharge_datetime ?? row.ipd_bill_ot ?? row.ipd_bill_datetime ?? null);
        return dt ? formatDateTime12h(dt) : '';
      },
      sortable: true,
      width: '200px'
    },
    {
      name: 'Action',
      cell: row => (
        <div className="d-flex gap-2">
         
         <button
  className="btn btn-sm btn-dark"
  onClick={() => handlePrintFinalBill(row)}
>
  IPD Final Bill Print
</button>


          {/* <button className="btn btn-sm btn-success" onClick={() => generateProvisionalBill({ ...row })}>Provisional Bill</button> */}
          <button className="btn btn-sm btn-warning" onClick={() => generateGatePass({ ...row })}>Gate Pass</button>
          <button className="btn btn-sm btn-primary" onClick={() => handleMoveToIpd(row)}>Move to IPD</button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      width: '380px'
    }
  ], [formData.l1, formData.wards, formData.doc, transactionHistory]);

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#f1f5fb',
        color: '#405189',
        fontSize: '15px',
        fontWeight: '700',
        paddingLeft: '14px',
        paddingRight: '14px',
      }
    },
    rows: {
      style: {
        fontSize: '16px',
        minHeight: '58px',
      },
    },
    cells: {
      style: {
        paddingLeft: '14px',
        paddingRight: '14px',
        fontSize: '15px',
        lineHeight: '20px'
      }
    },
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="card" id="orderList">
          <div className="card-header border-0">
            <div className="row align-items-center gy-3">
              <div className="col-sm"><h5 className="card-title mb-0">Discharge Patient List</h5></div>
              <div className="col-sm-auto">
                <div className="d-flex gap-1"></div>
              </div>
            </div>
          </div>

          <div className="card-body border border-dashed border-start-0 border-end-0">
            <div className="row g-3">
              <div className="col-md-2">
                <label>From</label>
                <input type="date" className="form-control" value={formData.from || ''} onChange={(e) => setFormData(prev => ({ ...prev, from: e.target.value }))} />
              </div>
              <div className="col-md-2">
                <label>To</label>
                <input type="date" className="form-control" value={formData.to || ''} onChange={(e) => setFormData(prev => ({ ...prev, to: e.target.value }))} />
              </div>
              <div className="col-md-4">
                <label>Search</label>
                <div style={{display:'flex', gap:8}}>
                  <input
                    className="form-control"
                    placeholder="Search by Patient Name..."

                    value={formData.search_key}
                    onChange={(e) => handleSearchInputChange(e.target.value)}
                    
                  />
                  <button className="btn btn-info" onClick={handleClear}>Clear</button>
                </div>
              </div>
            </div>
          </div>

          <div className="card-body pt-2">
            <div className="table-responsive table-card mb-1">
              <DataTable
                columns={columns}
                data={filteredRows}

                pagination
                highlightOnHover
                persistTableHead
                progressPending={loading}
                customStyles={customStyles}
                noHeader
                defaultSortFieldId={8}   // 🔥 Discharge Date/Time column index
                defaultSortAsc={false} 
              />
            </div>
            <div className="d-flex justify-content-end"></div>
          </div>
        </div>

        <DelBox />
      </div>
    </div>
  );
};

export default DisList;
